import { componentClassName } from '@/styles/BreakingNews';
import { ClassNameProp, Component, ComponentProps } from '@/types/component';
import mergeProps from 'lib/utils/mergeProps';
import { useBreakingNewsContext } from './BreakingNews';

export interface BreakingNewsItemBlipProps extends ComponentProps<'div'> {
  animation?: ClassNameProp;
  variant?: ClassNameProp<'default' | 'alternative'>;
  colors?: ClassNameProp<'default' | 'alternative'>;
  size?: ClassNameProp<'default' | 'alternative'>;
}

export const BreakingNewsItemBlipComponent: Component<BreakingNewsItemBlipProps> = ({
  animation,
  variant,
  size,
  colors,
  children,
  ...props
}) => {
  const { theme, ...contextClassNameProps } = useBreakingNewsContext({ colors, size, variant });
  const className = componentClassName('item_blip', { ...contextClassNameProps, animation }, { theme });

  return <div {...mergeProps({ className }, props)}>{children}</div>;
};
